<template>
	<div>
		<div class="foot ">
			<el-divider></el-divider>
			<el-row type="flex" justify="space-between" class="service wd-container">
				<el-col :span="6" class="wd-flex wd-row-center">
					<div class="a ico">7</div>
					<div class="wd-font-18">7天无理由退货</div>
				</el-col>
				<el-col :span="6" class="wd-flex wd-row-center">
					<div class="b ico">15</div>
					<div class="wd-font-18">15天免费换货</div>
				</el-col>
				<el-col :span="6" class="wd-flex wd-row-center">
					<div class="c ico"></div>
					<div class="wd-font-18">正品行货 品质保障</div>
				</el-col>
				<el-col :span="6" class="wd-flex wd-row-center">
					<div class="d ico"></div>
					<div class="wd-font-18">实体门店 售后服务</div>
				</el-col>
			</el-row>
			<el-divider></el-divider>
			<div class="wd-m-b-20">
				<el-row type="flex" justify="space-between" class="wd-container help">
					<el-col :span="18" class="">
						<div class="wd-flex wd-row-between wd-col-top">
							<div v-for="(item, index) in logininfo.helplist" :key="index">
								<div class="title">{{ item.name }}</div>
								<div v-for="(ditem, dindex) in item.detail" :key="dindex + '-' + index">
									<div class="memo">
										<router-link tag="span" class="wd-theme-999 wd-cursor wd-font-12" :to="{ path: '/help', query: { studyid: ditem.id } }">
											{{ ditem.title }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="4" class="wd-text-left">
						<div class="title">联系我们</div>
						<div class="memo wd-primary wd-font-xl wd-font-bold">{{ logininfo.companyinfo.telno }}</div>
						<div class="memo wd-info wd-font-sm">周一至周日9：00-21：00</div>
						<div class="memo wd-info wd-font-sm">（仅收市话费）</div>
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<div class="wd-m-t-10 wd-text-center wd-m-b-20">
				<div class="wd-m-b-10">Copyright © {{ logininfo.companyinfo.copyright }}</div>
				<div class="wd-m-b-10">{{ logininfo.companyinfo.name }}</div>
				<div class="wd-m-b-10">地址:{{ logininfo.companyinfo.linkaddr }}</div>
			</div>
		</div>
		<div class="serviceqrcodecss">
			<div class="cursor" @mouseenter="showkf=true" @mouseleave="showkf=false"><span class="wd-icon">&#xe609;</span></div>
			<div class="cursor" @click="gotop"><span class="wd-icon">&#xe60b;</span></div>
			<div class="kf" v-if="showkf">
				<el-image :src="$wdpicurl(logininfo.companyinfo.kfurl)"></el-image>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['logininfo'])
	},
	name: 'Footer',
	data() {
		return {
			helplist: [],
			showkf:false
		};
	},
	methods: {
		loadhelp() {
			this.$wd_request('studyclass', { classname: '商城帮助', help: 1 })
				.then(data => {
					this.$store.commit('sethelplist', data.value);
				})
				.catch(() => {});
		},
		loadcompany() {
			this.$wd_request('company')
				.then(data => {
					this.$store.commit('setcompanyinfo', data.value);
				})
				.catch(() => {});
		},
		gotop(){
			document.body.scrollIntoView();
		}
	},
	created() {
		if (this.$weidajs.isEmpty(this.logininfo.companyinfo)) {
			this.loadcompany();
		}
		if (this.$weidajs.isEmpty(this.logininfo.helplist)) {
			this.loadhelp();
		}
	}
};
</script>

<style lang="scss" scoped>
	.serviceqrcodecss {
		position: fixed;
		bottom: 0px;
		right:2px;
		z-index: 20;
		.cursor{
			color: #ffffff;
			width: 30px;
			height: 30px;
			text-align: center;
			line-height: 30px;
			background-color: #7a6e6e;
			margin-bottom: 2px;
			&:hover{
				background-color: $wd-theme;
				cursor: pointer;
			}
		}
		.kf{
			background-color: #fff;
			width: 250px;
			position: fixed;
			right: 35px;
			bottom: 35px;
			z-index: 1000;
		}
	}
	.help {
		.title {
			height: 30px;
			line-height: 30px;
		}
		.memo {
			height: 26px;
			line-height: 26px;
		}
	}
	.service {
		height: 56px;
		text-align: center;
		.ico {
			display: inline-block;
			width: 49px;
			height: 56px;
			text-align: center;
			line-height: 56px;
			color: #e40000;
			font-size: 21px;
			margin-right: 16px;
			background-image: url(../../assets/footpic.png);
			background-repeat: no-repeat;
			&.a {
				background-position: 0 -27px;
			}
			&.b {
				background-position: -50px -27px;
			}
			&.c {
				background-position: -100px -27px;
			}
			&.d {
				background-position: -150px -27px;
			}
		}
	}
	.foot {
		background-color: #ffffff;
	}
</style>
